import * as React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { StockList } from 'components/StockList';
import { PageTitle } from 'components/PageTitle';
import { IdeaFilters } from 'components/IdeaFilter';

export const StocksPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="content">
      <Helmet>
        <title>{t('Stocks and ETF investments')}</title>
        <meta name="description" content={t('We offer only reliable ideas')} />
      </Helmet>
      <section>
        <PageTitle>{t('Stocks and ETF investments')}</PageTitle>
        <IdeaFilters root="/investments" />
        <StockList />
      </section>
    </div>
  );
};
